import { FormModal } from "components/Common/FormModal";
import { Form, Formik } from "formik";
import { Requests } from "libs/Api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setLoading, setToastr } from "slices/CommonSlice";
import { getEntityUrl } from "utils/CommonUtils";
import { BRANCH_OPTIONS } from "./Constants";
import { Checkbox } from "./FormElements/Checkbox";
import Input from "./FormElements/Input";
import { InputBase } from "./FormElements/InputBase";
import { PatternFormatInput } from "./FormElements/PatternFormatInput";
import Select from "./FormElements/Select";
import { TextArea } from "./FormElements/TextArea";
import { CareerFormSchema } from "./Validation/CareerFormSchema";

export const Index = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  let initialValues = {
    FirstName: "",
    LastName: "",
    EmailAddress: "",
    Branch: "",
    MobileNumber: "",
    Content: "",
    Approval0: false,
    Approval1: false,
    Approval2: false,
  };
  const [initialState, setInitialState] = useState(initialValues);

  useEffect(() => {
    setInitialState({ ...initialState, Branch: location.state?.branchType });
  }, [location]);

  const [showModal, setshowModal] = useState({
    open: false,
    title: "",
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setshowModal({ open: false, title: "" });
  };

  const getOfferFormSubmit = async (values) => {
    try {
      let url = getEntityUrl({
        api: {
          url: `Users/SendGuestOfferForm`,
          baseName: "BaseApiName",
        },
      });
      dispatch(setLoading(true));
      let content = {
        ...values,
        MobileNumber: values.MobileNumber.replaceAll(" ", ""),
      };
      const response = await Requests().CommonRequest.post({
        url,
        content,
      });
      setInitialState(initialValues);
      setshowModal({
        open: true,
        title: t("getOffer.sectionForm.inputs.formSuccess"),
      });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(
        setToastr({
          open: true,
          message: t("getOffer.sectionForm.inputs.formError"),
          severity: "error",
        })
      );
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-98px)] bg-get-offer bg-center bg-cover bg-no-repeat">
      <div className="flex-1 flex justify-center py-10 px-10 relative bg-[#014789] bg-opacity-50">
        <div className="max-w-xl 2xl:max-w-2xl w-full">
          <h1 className="font-abrilFatface text-4xl lg:text-[60px] text-white text-center lg:text-start">
            {t("getOffer.title")}
          </h1>
          <Formik
            enableReinitialize
            initialValues={initialState}
            validationSchema={CareerFormSchema}
            onSubmit={(values) => getOfferFormSubmit(values)}
          >
            {({ handleSubmit, handleChange, handleBlur, setFieldValue }) => (
              <Form
                onSubmit={handleSubmit}
                className="flex flex-col lg:grid lg:grid-cols-2 items-center gap-y-3 gap-x-4 mt-6 lg:mt-12 text-white"
              >
                <InputBase
                  label={t("getOffer.sectionForm.inputs.name.label")}
                  component={Input}
                  inputClassName="h-12 text-black text-[15px]"
                  placeholder={t(
                    "getOffer.sectionForm.inputs.name.placeHolder"
                  )}
                  type="text"
                  name="FirstName"
                />
                <InputBase
                  label={t("getOffer.sectionForm.inputs.lastname.label")}
                  component={Input}
                  inputClassName="h-12 text-black text-[15px]"
                  placeholder={t(
                    "getOffer.sectionForm.inputs.lastname.placeHolder"
                  )}
                  type="text"
                  name="LastName"
                />
                <InputBase
                  label={t("getOffer.sectionForm.inputs.eMail.label")}
                  component={Input}
                  inputClassName="h-12 text-black text-sm text-[15px]"
                  placeholder={t(
                    "getOffer.sectionForm.inputs.eMail.placeHolder"
                  )}
                  type="text"
                  name="EmailAddress"
                />
                <InputBase
                  label={t("getOffer.sectionForm.inputs.phoneNumber.label")}
                  component={PatternFormatInput}
                  inputClassName="h-12 text-black text-[15px]"
                  type="text"
                  name="MobileNumber"
                  format="0 ### ### ## ##"
                />
                <InputBase
                  label={t("getOffer.sectionForm.inputs.branch.label")}
                  component={Select}
                  options={BRANCH_OPTIONS}
                  placeholder={t(
                    "getOffer.sectionForm.inputs.branch.placeHolder"
                  )}
                  inputClassName="h-12 text-black text-[15px]"
                  type="text"
                  name="Branch"
                />
                <div className="col-span-2 w-full">
                  <InputBase
                    label={t("getOffer.sectionForm.inputs.content.label")}
                    component={TextArea}
                    inputClassName="text-black text-[15px]"
                    placeholder={t(
                      "getOffer.sectionForm.inputs.content.placeHolder"
                    )}
                    type="text"
                    name="Content"
                  />
                </div>
                <div className="col-span-2 flex flex-col gap-y-1">
                  <Checkbox
                    setFieldValue={setFieldValue}
                    modal={{
                      title: t(
                        "getOffer.sectionForm.approvalDetails.approvalOne.name"
                      ),
                      content: t(
                        "getOffer.sectionForm.approvalDetails.approvalOne.content"
                      ),
                    }}
                    showModal={true}
                    name={`Approval0`}
                    btnLabel={t(
                      "getOffer.sectionForm.approvalDetails.approvalOne.name"
                    )}
                    label={t(
                      "getOffer.sectionForm.approvalDetails.acceptedTitle"
                    )}
                  />
                  <Checkbox
                    setFieldValue={setFieldValue}
                    modal={{
                      title: t(
                        "getOffer.sectionForm.approvalDetails.approvalTwo.name"
                      ),
                      content: t(
                        "getOffer.sectionForm.approvalDetails.approvalTwo.content"
                      ),
                    }}
                    showModal={true}
                    name={`Approval0`}
                    btnLabel={t(
                      "getOffer.sectionForm.approvalDetails.approvalTwo.name"
                    )}
                    label={t(
                      "getOffer.sectionForm.approvalDetails.acceptedTitle"
                    )}
                  />
                  <Checkbox
                    setFieldValue={setFieldValue}
                    modal={{
                      title: t(
                        "getOffer.sectionForm.approvalDetails.approvalThree.name"
                      ),
                      content: t(
                        "getOffer.sectionForm.approvalDetails.approvalThree.content"
                      ),
                    }}
                    showModal={true}
                    name={`Approval0`}
                    btnLabel={t(
                      "getOffer.sectionForm.approvalDetails.approvalThree.name"
                    )}
                    label={t(
                      "getOffer.sectionForm.approvalDetails.acceptedTitle"
                    )}
                  />
                  {/* {APPROVALS &&
                    APPROVALS.map((approval, index) => (
                      <Checkbox
                        setFieldValue={setFieldValue}
                        modal={{
                          title: approval?.ApprovalDetail?.Name,
                          content: approval?.ApprovalDetail?.Content,
                        }}
                        showModal={true}
                        name={`Approval${index}`}
                        btnLabel={approval?.ApprovalDetail?.Name}
                        label={t("getOffer.sectionForm.inputs.approvals.label")}
                      />
                    ))} */}
                </div>
                <div className="col-span-2 flex justify-center mt-16">
                  <button
                    type="submit"
                    className="h-12 bg-[#4A98F7] px-7 text-white font-bold text-xl rounded-2xl"
                  >
                    {t("getOffer.sectionForm.inputs.buttonTitle")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="flex-1 relative hidden lg:flex bg-[#014789] opacity-50 lg:justify-start lg:items-start"></div>
      {showModal.open && (
        <FormModal
          open={showModal.open}
          title={showModal.title}
          handleClose={handleClose}
          buttonColor="bg-[#4FA758]"
          // handleClose={() => {
          //   setshowModal({ open: false, title: "", details: "", imgUrl: "" });
          // }}
        />
      )}
    </div>
  );
};
